import { useCallback, useState } from 'react'

type UseModal = {
  closeModal: () => void
  open: boolean
  openModal: () => void
}

const useModal = (): UseModal => {
  const [open, setOpen] = useState<boolean>(false)
  const openModal = useCallback(() => setOpen(true), [setOpen])
  const closeModal = useCallback(() => setOpen(false), [setOpen])
  return {
    closeModal,
    open,
    openModal,
  }
}

export default useModal
